<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <OrderDetailComponent :order="order"></OrderDetailComponent>
      </v-col>
      <v-col>
        <v-row>
          <a v-if="terms" :href="terms" download target="_blank">
            <v-btn color="primary" block class="rounded-lg mb-8" elevation="2"
              >Download Terms and Conditions</v-btn
            >
          </a>
        </v-row>
        <v-row>
          <v-btn
            text
            :color="requireResign ? 'green' : 'grey'"
            @click="requireResign ? requireResignTeam(false) : requireResignTeam(true)">
            Require Resigning of Terms and Conditions
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          text
          :color="droppedOut ? 'grey' : 'green'"
          @click="droppedOut ? dropOutTeam(false) : dropOutTeam(true)">
          {{ droppedOut ? 'Dropped Out' : 'Active' }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        Validation Type: {{ validateType }}
        <div v-if="validateType === 'EMAIL'">Email: {{ validationEmail }}</div>
        <div v-if="validateType === 'PHOTO' && validationAsset">
          <AssetPreviewComponent :asset="validationAsset" type="image" disableUpload="true" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { ITeamDTO, OrderDTO, TeamDTO } from '@/dtos';
import OrderDetailComponent from '@/components/orders/OrderDetailComponent.vue';
import { useTeamStore } from '@/stores';
import AssetPreviewComponent from '@/components/ui/AssetPreviewComponent.vue';

interface Props {
  teamId: string;
  yearId: string;
  team: ITeamDTO;
}
const props = defineProps<Props>();

const team = ref<ITeamDTO>(new TeamDTO());

watch(
  () => props.team,
  () => {
    team.value = new TeamDTO(props.team);
  },
  { immediate: true },
);

const teamStore = useTeamStore();
const droppedOut = computed(() => team.value.teamCriteria[0]?.dropped_out ?? false);
const requireResign = computed(() => team.value.teamCriteria[0]?.force_redo_terms ?? false);

const terms = computed(() => {
  return team.value.teamCriteria[0]?.terms?.url ?? '';
});
const order = computed(() => {
  return new OrderDTO(team.value.teamCriteria[0]?.order);
});

const validateType = computed(() => {
  return team.value.teamCriteria[0]?.validationType ?? '';
});

const validationEmail = computed(() => {
  return team.value.teamCriteria[0]?.validationEmail ?? '';
});

const validationAsset = computed(() => {
  return team.value.teamCriteria[0]?.validationAsset ?? null;
});

const dropOutTeam = async (dropOut: boolean) => {
  teamStore.dropOut.mutateAsync({ teamId: team.value.id, yearId: props.yearId, dropOut: dropOut });
};

const requireResignTeam = async (requireResign: boolean) => {
  teamStore.requireResign.mutateAsync({
    teamId: team.value.id,
    yearId: props.yearId,
    requireResign: requireResign,
  });
};
</script>
